import { isEmpty, isEmail, formatMobilePhone } from '@jjj/components';
import { isMobilePhone } from '../../../../helpers/validators';
import actions from './actions';
import { createReducer, getError } from '../../../../helpers/reducer';
import { keyBy } from '../../../../helpers/core';
import { t } from '../../../../i18n';

const initState = {
  demoUser: null,
  loading: false,
  editForm: null,
  isEdit: false,
  formInfo: {},
  deleted: false,
};

const initialEditData = {
  first_name: null,
  last_name: null,
  role: null,
  email: null,
  phone_number: null,
  avatar_url: null,
};

function validate(attr, value, params) {
  let error = '';

  if (attr === 'first_name') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.admin.demoUsers.columns.first_name_title') });
    } else if (value.length >= 45) {
      error = t('dash.validation.max_length_error', { fieldName: t('dash.admin.demoUsers.columns.first_name_title') });
    }
  }

  if (attr === 'last_name') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.admin.demoUsers.columns.last_name_title') });
    } else if (value.length >= 45) {
      error = t('dash.validation.max_length_error', { fieldName: t('dash.admin.demoUsers.columns.last_name_title') });
    }
  }

  if (attr === 'role') {
    if (isEmpty(value)) {
      error = t('dash.validation.select_a_field', { fieldName: t('dash.admin.demoUsers.columns.role_title') });
    }
  }

  if (attr === 'email') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.admin.demoUsers.columns.email_title') });
    } else if (!isEmail(value)) {
      error = t('dash.validation.valid_error', { fieldName: t('dash.admin.demoUsers.columns.email_title') });
    }
  }

  if (attr === 'phone_number') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.admin.demoUsers.columns.phone_title') });
    } else if (!isMobilePhone(formatMobilePhone(value), params?.phoneNumberCountry)) {
      error = t('dash.validation.valid_error', { fieldName: t('dash.admin.demoUsers.columns.phone_title') });
    }
  }

  return error;
}

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const demoUser = data;

  return {
    ...state,
    demoUser,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

function onEdit(state, { payload }) {
  const propsArray = Object.keys(payload.demoUser);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: payload.demoUser[prop],
      error: validate(prop, payload.demoUser[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    isEdit: true,
    editForm,
  };
}

function onSaveSuccess(state, { payload }) {
  const { data } = payload;
  const demoUser = data;

  return {
    ...state,
    demoUser,
    isEdit: false,
    editForm: null,
  };
}

function onDelete(state) {
  return {
    ...state,
    isEdit: false,
    editForm: null,
  };
}

function onDeleteSuccess(state) {
  return {
    ...state,
    deleted: true,
  };
}

function onSaveError(state, { payload }) {
  const { data } = payload;

  const propsArray = Object.entries(state.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        error: getError(entry[0], data),
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

function onCreate(state) {
  const propsArray = Object.keys(initialEditData);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: initialEditData[prop],
      error: validate(prop, initialEditData[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    isEdit: true,
    demoUser: initialEditData,
    editForm,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value, params } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value, params),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onCancel(state) {
  return {
    ...state,
    isEdit: false,
    editForm: null,
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

function onLoadFormData(state, { payload }) {
  const { data } = payload;

  return {
    ...state,
    formInfo: data,
  };
}

export { validate };
export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.EDIT]: onEdit,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CANCEL]: onCancel,
  [actions.SAVE_SUCCESS]: onSaveSuccess,
  [actions.SAVE_ERROR]: onSaveError,
  [actions.DELETE]: onDelete,
  [actions.DELETE_SUCCESS]: onDeleteSuccess,
  [actions.CREATE]: onCreate,
  [actions.TOUCH]: onTouch,
  [actions.LOAD_FORM_DATA]: onLoadFormData,
});
